import { render, staticRenderFns } from "./UserNotificationsMenu.vue?vue&type=template&id=4584bad8&"
import script from "./UserNotificationsMenu.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports